import { render, staticRenderFns } from "./BaseCampaignTemplateTab.vue?vue&type=template&id=1e22ef78&scoped=true&"
import script from "./BaseCampaignTemplateTab.vue?vue&type=script&lang=js&"
export * from "./BaseCampaignTemplateTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e22ef78",
  null
  
)

export default component.exports